'use client'
import React from 'react'
import dynamic from 'next/dynamic'
import Head from 'next/head'

import ContactSection from '../../../app/_components/Section/Contact'
import Image from 'next/image'
import PageBanner from '../PageBanner'

const CertificateImageSlider = dynamic(
  () => import('../../../app/_components/Sliders/CertificateImages'),
  {
    ssr: false,
  },
)
const About: React.FC = () => {
  return (
    <>
      <Head>
        <title>Team - Pyther Innovation</title>
        {/* <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SERVER_URL}/about-us`} /> */}
      </Head>
      <PageBanner pageName={'About us'} pageTitle={'Our Core Values'} />

      {/* about section */}
      <section className="mil-deep-bg mil-p-40-0" style={{paddingTop:0}}>
        <div className="mil-deco" style={{ top: 0, left: '35%' }} />
        <div className="container ">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-5  service-Image">
              <div className="mil-circle-illustrations">
                <div className="mil-image-frame">
                  <Image src="/img/career/himachal-trip.jpg" alt="trip Image" width={800} height={1008} />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <h2 className="mil-h2" style={{marginBottom:"30px", marginTop:"35px"}}>
                <p style={{marginBottom:'0'}}>A team of people </p>
                <p style={{marginBottom:'0'}}><span className="mil-accent">with full on passion and</span> </p>
                <p style={{marginBottom:'0'}}>
                every work possibilities.</p>
                {/* A team of people with full on passion and every work possibilities. */}
              </h2>
              <p className="mil-mb-30 mil-dig-text" style={{ textAlign: 'justify' }}>
                Pyther Innovations was established in 2008 as an independent company to provide
                technology solutions for their customers around the world. We offer software
                development services such as web app development, mobile application development,
                IoT development, eCommerce development and salesforce development. Our skilled IT
                engineers are dedicated to delivering top-quality products that meet client
                expectations.
                <br />
                <br />
                We also offer custom software development services including digital transformation
                and connected IoT solutions across various cloud platforms, including AWS. Our
                expertise in Mobility (iOS / Android), React Native, ReactJS, JavaScript, Vue JS,
                NodeJS, Next.js, Java, J2EE, PHP, IoT space and many more.
                <br />
                <br />
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our mission our vision section */}
      <section className="mil-p-40-10">
        <div className="container mil-p-40">
          <div className="mil-divider" />
          <div className="mil-line-icon-box">
            <div className="row align-items-center">
              <div className="col-xl-2 p-2">
                <Image src="/img/photo/vision.png" height={100} width={100} alt="Our Vision" />
              </div>
              <div className="col-xl-4">
                <h3 className="mil-h3 my-2">Our Vision : </h3>
              </div>
              <div className="col-xl-6" style={{ textAlign: 'justify' }}>
                <p className="mil-box-text mil-dig-text mb-1">
                  Our vision is to be a leading technology company that empowers businesses and individuals to realize their full potential through innovative, reliable, and secure digital solutions.
              
                </p>
              </div>
            </div>
          </div>
          <div className="mil-divider" />
          <div className="mil-line-icon-box">
            <div className="row align-items-center">
              <div className="col-xl-2 p-2">
                <Image src="/img/photo/mission.png" height={100} width={100} alt="Our Mission" />
              </div>
              <div className="col-xl-4">
                <h3 className="mil-h3 my-2">Our Mission:</h3>
                {/* vision.png */}
              </div>
              <div className="col-xl-6">
                <p className="mil-box-text mil-dig-text" style={{ textAlign: 'justify' }}>
                  <span className="mil-accent" style={{ fontSize: '1.3rem', marginBottom: '1rem' }}>
                    01 :{' '}
                  </span>{' '}
                 
                  Our mission is to leverage technology to empower businesses and individuals,
                  creating innovative solutions that transform the way people work, live, and
                  connect with each other.
                </p>
                <p className="mil-box-text mil-mb-30 mil-dig-text" style={{ textAlign: 'justify' }}>
                  <span className="mil-accent" style={{ fontSize: '1.3rem', marginBottom: '1rem' }}>
                    02 :{' '}
                  </span>{' '}
                
                  Create technology that enhances people's lives. We are driven by a passion for
                  innovation and a dedication to quality, and we strive to exceed our customers'
                  expectations every time.
                </p>
                <p className="mil-box-text mil-mb-30 mil-dig-text" style={{ textAlign: 'justify' }}>
                  <span className="mil-accent" style={{ fontSize: '1.3rem', marginBottom: '1rem' }}>
                    03 :{' '}
                  </span>{' '}
                
                  We are committed to delivering superior quality, reliability, and value to our
                  customers, and we believe in building long-term relationships based on trust and
                  respect.
                </p>
              </div>
            </div>
          </div>
          <div className="mil-divider" />
          <div className="mil-line-icon-box">
            <div className="row align-items-center">
              <div className="col-xl-2 p-2">
                <Image src="/img/photo/work-experience.png" height={100} width={100} alt="Work Experience" />
              </div>
              <div className="col-xl-4">
                <h3 className="mil-h3 my-2">Work Experience : </h3>
              </div>
              <div className="col-xl-6" style={{ textAlign: 'justify' }}>
                <p className="mil-box-text mil-dig-text mb-1">
                  As a trusted partner, we are committed to providing our clients with ongoing support and guidance. With 15+ years of work experience and over 530 projects under our belt, we believe that building a successful technology platform is an ongoing process, and we are there every step of the way to ensure that our clients achieve their goals. Whether it's providing advice, troubleshooting issues, or implementing new features, our team is always ready to assist.
             
                </p>
              </div>
            </div>
          </div>
          <div className="mil-divider mb-1" />
  
        </div>
      </section>

      {/* Certificate slider section */}
      <CertificateImageSlider />

      {/* Contact section */}
      <ContactSection />
    </>
  )
}

export default About
